import Script from 'next/script'

const ZendeskScriptTag = () => {
  return (
    <>
      <Script
        id="zendesk-settings"
        strategy="afterInteractive" // Changed from lazyOnload for earlier initialization
        dangerouslySetInnerHTML={{
          __html: `
            window.zESettings = {
              webWidget: {
                chat: {
                  suppress: false,
                  connectOnPageLoad: true
                },
                contactForm: {
                  suppress: false
                },
                helpCenter: {
                  suppress: false
                }
              }
            };
          `,
        }}
      />
      <Script
        id="ze-snippet"
        strategy="afterInteractive" // Changed from lazyOnload
        src="https://static.zdassets.com/ekr/snippet.js?key=7546d5a8-a3cd-4869-a767-a0da28d2511d"
        onLoad={() => console.log('Zendesk widget loaded successfully')}
        onError={() => console.error('Failed to load Zendesk widget')}
      />
    </>
  )
}

export default ZendeskScriptTag
